import i18n from '@/plugins/i18n';
import { DataTypes } from '@/utils/enums/dataTypes';
import { SortOrder } from '@/utils/enums/sortOrder';

const SecretTableHeaders = () => [
  {
    key: 'secretType',
    name: i18n.global.t('sm.secretType'),
    width: '15%',
    sortable: true,
  },
  {
    key: 'secretKey',
    name: i18n.global.t('sm.secretName'),
    width: '31%',
    sortable: true,
  },
  {
    key: 'isVisible',
    name: i18n.global.t('sm.visibility'),
    width: '15%',
    sortable: true,
  },
  {
    key: 'updatedAt',
    name: i18n.global.t('lastModified'),
    sortable: true,
    width: '15%',
  },
  {
    key: 'createdAt',
    name: i18n.global.t('createdOn'),
    sortable: true,
    width: '15%',
  },
  {
    key: 'actionItems',
    name: i18n.global.t('sm.actionItems'),
    width: '9%',
    sortable: false,
  },
];

const TokensListHeaders = [
  {
    key: 'tokenName',
    name: i18n.global.t('sm.configuredTokens'),
    width: '33%',
  },
];

const clientId = 'CLIENT_ID';
const accessTokenUrl = 'ACCESS_TOKEN_URL';
const clientSecret = 'CLIENT_SECRET';
const scope = 'SCOPE';
const audience = 'AUDIENCE';
const resource = 'RESOURCE';

const SecretTypeList = [
  { name: 'Client ID', value: clientId },
  { name: 'Access URL', value: accessTokenUrl },
  { name: 'Client Secret', value: clientSecret },
  { name: 'Scope', value: scope },
  { name: 'Audience', value: audience },
  { name: 'Resource', value: resource },
];

const sortFieldMapping = {
  secretType: 'secret_type',
  createdAt: 'created_at',
  updatedAt: 'updated_at',
  secretKey: 'secret_key',
  isVisible: 'is_visible',
  tokenName: 'token_name',
  endpointCount: 'endpoint_count',
};

const sortOrder = {
  asc: 'ASC',
  desc: 'DESC',
};

const defaultSortingParams = {
  sortBy: sortFieldMapping.updatedAt,
  sortByType: sortOrder.desc,
};

export {
  SecretTableHeaders,
  SecretTypeList,
  clientId,
  accessTokenUrl,
  clientSecret,
  scope,
  audience,
  resource,
  defaultSortingParams,
  sortFieldMapping,
  sortOrder,
  TokensListHeaders,
};
